import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
  jp: {
    home: "ホーム",
    about: "こんな方におすすめ",
    services: "サービスの特徴",
    pricing: "料金",
    trainer: "トレーナー",
    counseling: "無料カウンセリング",
    philosophy: "企業理念",
    founder: "創業者紹介",
    language: "言語を選択",
    english: "英語",
    japanese: "日本語",
    home_banner_text: "50代、60代、70代からはじめる\n健康でいるためのパーソナルジム",
    book_counseling: "無料カウンセリングを予約する",
    recommended_title: "こんな方におすすめ",
    recommended_1: "運動習慣がない方",
    recommended_2: "パーソナルジムは辛いトレーニングと食事制限がありそうで嫌だ",
    recommended_3: "ジム通うのにハードルを感じる方",
    service_title: "パーソナルジムとは",
    service_description:
      "「パーソナルジムは、完全予約制でトレーナーがマンツーマンでサポートするジムです。 年齢に合わせたダイエットプランや、目標や体力に合わせたオーダーメイドのトレーニングプランを提供します。プライベート空間なので、周りを気にせず自分のペースで運動に集中できます。」",
    Trainer_title: "トレーナー紹介",
    Trainer_name:' 君塚龍二',
    Trainer_description:
      "ベストライフフィットネス代表 / パーソナルトレーナー スポーツ分野を専門的に学び、ゴールドジムを運営するTHINKフィットネスで7年以上の指導経験を持つ。90歳近い高齢者からアスリートまで幅広い層に対応可能。 幼少期の困難な経験を経て、多くの人に健康を届けたいという思いでベストライフフィットネスを創設。講演やセミナーを通じて、健康促進と公平な社会を目指した活動も展開している。",
    Calander_title1:"無料カウンセリング" ,
    Calander_title2:' 予約をすることで、',
    Calander_link1:'利用規約',
    Calander_link2:'プライバシーポリシー',
    Calander_text1:'および',
    Calander_text2:'に同意したものとみなされます。',
    philosophy_description: " 50代・60代・70代でも健康でいるために\n私たちは、年齢に関係なく適切な運動が健康を維持するうえで不可欠だと考えています。特に50代から70代にかけては、体力や筋力が自然と低下していくため、無理のない範囲で運動を始め、継続することが健康寿命を延ばす鍵となります。\n 生活習慣病やその他多くの病気の原因は、実は「運動不足」によることが少なくありません。運動を取り入れないことで、以下のような健康リスクが高まります：\n- 筋力や体力の低下により、日常生活に支障が出る\n - 血糖値や血圧の上昇など、生活習慣病のリスクが高まる\n - 骨密度の減少による骨粗しょう症や転倒リスクの増加\nこれらを防ぐためにも、適切な運動量を日常生活に取り入れることが重要です。\n 無理なく始めて、続けられる運動習慣を ",
    philosophy_more: "「もう歳だから無理だろう…」と思われるかもしれませんが、今からでも遅くありません。ベストライフフィットネスでは、50代から70代の方でも安心して取り組める運動プログラムを提案し、お客様一人ひとりに寄り添ったサポートを行っています。いきなり激しい運動をする必要はありません。優しいストレッチや体に負担をかけないトレーニングから始め、少しずつ続けていくことで、生活習慣病の予防だけでなく、日常生活がより快適になり、心身ともに健康を維持できます。ベストライフフィットネスでは、「今からでも始められる」「無理なく続けられる」を大切に、運動習慣の定着を全力でサポートします。一緒に健康的な未来を作っていきましょう！",



    footer_title:"電話 / メールアドレス",
    footer_phone:"080-7998-3831",
    footer_email:"info@bestlifefitness.jp",
    footer_SNS:"SNS",
    footer_Instagram:"Instagram",
    footer_line:"Line",
    
    plane_title:" 料金プラン",
    plane_disctiption:"入会金5,500円 → キャンペーン中のため無料<br /> 先着30名様限定",
  }
});

export default strings;
